export const en = {
    execution_date: 'Execution date',
};
